// options: string[] or { value: string, label: string }[] (mixed allowed).
import { ChevronDown } from "lucide-react";

export default function Select({ label, value, onChange, options, disabled }) {
  const handleChange = (e) => {
    if (!onChange || typeof onChange !== "function") return;
    const val = (e && e.target && e.target.value) || "";
    onChange(val);
  };

  const current = String(value ?? "");
  const optionValue = (o) =>
    typeof o === "object" && o !== null && Object.prototype.hasOwnProperty.call(o, "value") ? String(o.value) : String(o);
  // A value that is not one of the options (blank, or a saved value no longer listed) would make the
  // browser show the first option while the form still holds the old value -- what you see is then
  // not what gets saved. Show the real value instead.
  const missing = !options.some((o) => o != null && optionValue(o) === current);

  return (
    <label className="block">
      {label ? (
        <div className="mb-1 text-xs font-semibold text-gray-700">{label}</div>
      ) : null}
      <div className="relative">
        <select
          value={current}
          onChange={disabled ? undefined : handleChange}
          disabled={disabled}
          className="w-full appearance-none rounded-xl border bg-white px-3 py-2 pr-9 text-sm outline-none transition focus:border-gray-900 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-400"
        >
          {missing ? (
            <option value={current} disabled={current === ""}>{current === "" ? "Select…" : current}</option>
          ) : null}
          {options.map((o, idx) => {
            if (o == null) return null;
            const isObject =
              typeof o === "object" &&
              o !== null &&
              Object.prototype.hasOwnProperty.call(o, "value");
            const optValue = isObject ? String(o.value) : String(o);
            const optLabel =
              isObject && o.label != null ? String(o.label) : String(o);
            const key =
              optValue === "" ? `opt-empty-${idx}` : `${optValue}-${idx}`;
            return (
              <option key={key} value={optValue}>
                {optLabel}
              </option>
            );
          })}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      </div>
    </label>
  );
}
